import v1_pay_membergood_h5list from "@/api/name/v1_pay_membergood_h5list.api.js";
import v1_vip_membergood_detail from "@/api/name/v1_vip_membergood_detail.api.js";

const formatApiRes = (res) => {
    let result = {};
    if (!res.code) {
        result = res.data;
    } else {
        result = res;    
    }
    return {
        code : result.code || 0,
        data : result.data || {},
        message : result.message || "",
    };
};
const formatApiResError = (error) => {
    return {code:-1,data:{},message:error};
};
//获取列表
export const getH5Membergoods = (data) => {
    return new Promise(resolve => {
        v1_pay_membergood_h5list(data).then(res => {
            resolve(formatApiRes(res));
        }).catch(error => {
            resolve(formatApiResError(error));
        });
    });
};
//获取detail
export const getH5Memberdetail = (data) => {
    return new Promise(resolve => {
        v1_vip_membergood_detail(data).then(res => {
            resolve(formatApiRes(res));
        }).catch(error => {
            resolve(formatApiResError(error));
        });
    });
};

const apiserver = {
    getH5Membergoods
};
export default apiserver;



// WEBPACK FOOTER //
// ./src/components/web/pay/js/api.js